import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

import { useTabPanelContext } from '../context';

interface TabPanelProps {
    children: React.ReactNode;
    name: string;
    visibleTab?: string;
}

function TabPanel({ children, name, visibleTab = '' }: TabPanelProps) {
    const { currentTab, registerTab } = useTabPanelContext();
    const panelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        registerTab(name);
    }, [name, registerTab]);

    return (
        <Box
            ref={panelRef}
            style={{
                width: '100%',
                height: visibleTab === name || currentTab === name ? '100%' : '0',
                overflow: visibleTab === name || currentTab === name ? 'initial' : 'hidden',
                flexGrow: 1,
                flexShrink: 0,
            }}>
            {children}
        </Box>
    );
}

export default TabPanel;
